import React from 'react';
import { Link } from 'react-router-dom'

const ProductoCabecera = (props) => (
 	<section className="col-md-8  float-left">
        <nav className="migas" role="navigation" aria-label="breadcrumb">
           	<ol className="breadcrumb" >
             	<li className="breadcrumb-item"><Link to={'/'} >Home</Link></li>
              { props.producto.id_rubro===1 &&
              <li className="breadcrumb-item"><Link to={'/productos/'+props.producto.id_rubro+"/"+props.producto.id_categoria} >{ props.producto.rubro_nombre } { props.producto.cat_nombre }</Link></li>
              }
              { props.producto.id_rubro>1 &&
              <li className="breadcrumb-item"><Link to={'/productos/'+props.producto.id_rubro+"/"+props.producto.id_categoria} >{ props.producto.rubro_nombre }</Link></li>
              }
             	<li className="breadcrumb-item active" aria-current="page">{ props.producto.nombre }</li>
           	</ol>
        </nav>
        <hgroup>
           	<h2 className="display-4 text-info tit-font">{ props.producto.nombre }</h2>
           	<p  className="lead ">{ props.producto.descripcion }</p>
        </hgroup>
    </section>
);

export default ProductoCabecera;



// WEBPACK FOOTER //
// ./src/components/prodcabecera.js